import { Component, OnInit ,ElementRef, ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { GlobalService } from "../global-service";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
  AbstractControl, ValidationErrors
} from "@angular/forms";
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import * as moment from 'moment';
@Component({
  selector: 'app-campaign-details',
  templateUrl: './campaign-details.component.html',
  styleUrls: ['./campaign-details.component.css']
})
export class CampaignDetailsComponent implements OnInit {
  @ViewChild('content') content!: ElementRef;
  data: any = [];
  detailData: any;
  addEntryModel: boolean = false;
  viewEntryModel: boolean = false;
  tournamentId: any;
  tournamentList: any;
  tournamentObj: any;
  stateName: any;
  archerList: any;
  archerListObj: any = [];
  ApprovedApplicants: any = [];
  ApprovedEscortArcherList: any = [];
  selectedArcherObj: any;
  addEntryFormGroup: FormGroup;
  archerId: any
  playingCategory: any;
  successMsg: boolean = false;
  listOfEntries: any;
  allEntries: any;
  arrangeName: any;
  selectedCategoryCount: any = [];
  allFinalEntries: any;
  transportTypeObj: any = [];
  addTransportFormGroup: FormGroup;
  type: any
  vehicleNumber: any
  arrivalPlace: any
  arrivalDateAndTime: any
  departurePlace: any
  departureDateAndTime: any
  transportationList: any
  showTicketField: boolean = false;
  labelName: string;
  viewCategoryName: string;
  summaryDetails: any;
  coachesListObject: any;
  tempCoachesData: any;
  coachList: boolean = false;
  categoryObj: any;
  coachId: any;
  listOfCoachEntries: any;
  listOfEscortAttendantEntries: any;
  listOfTeamOfficialData: any;
  isArcher: boolean = false;
  noRecordFound: boolean = false;
  tempTeamOfficialData: any
  teamOfficialList: boolean = false;
  submitted = false;
  submit = false;
  buttonFlag = false;
  categoriesArray: any;
  loading: boolean = false;
  selectedCategory: string = '';
  limitMsg: boolean = false;
  errorMsg: string = '';
  escortErrorMsg: string = '';
  escortLimitMsg: boolean = false;
  associationFullName:string = '';
  onlyPdfContent:boolean = false;
  isEscortAttendant: boolean = false;
  escortEntryList: boolean = false;
  genderListObj: any;
  ApprovedEscortAttendants: any;
  escortAttendantListObj: any;
  escortArcherListObj: any;
  escortArcherErrorMsg: string = '';
  isEscortArcherErrorMsg: boolean = false;
  constructor(
    public global: GlobalService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder

  ) // private messageService: MessageService
  {
    this.archerListObj = [

    ];

    this.transportTypeObj = [
      { label: "By Road", value: "By Road" },
      { label: "By Train", value: "By Train" },
      { label: "By Air", value: "By Air" },
    ]

    this.coachesListObject = []
    this.categoryObj = [
      { label: "Compound", value: "Compound" },
      { label: "Indian Round", value: "Indian Round" },
      { label: "Recurve", value: "Recurve" },
      { label: "W1", value: "W1" },
      { label: "VI 1 (Visually Impaired)", value: "VI 1" },
      { label: "VI 2/3 (Visually Impaired)", value: "VI 2/3" },
    ]
    this.genderListObj = [
      { label: "Male", value: "Male" },
      { label: "Female", value: "Female" },
    ]
  }

  ngOnInit(): void {

    this.tournamentId = this.route.snapshot.paramMap.get("id");
    this.addTransportFormGroup;
    this.getTournamentList()
    this.getArcherList()
    this.tournamentForm();
    this.transportForm();
    this.getTransportationList();
    this.getTournamentSummary();
    this.getAssociationFullName();
    this.getEscortAttendantInfo();
    this.getEscortAllArcherList();
    setTimeout(() => {
      this.getTotalCategoryValueSum();
      this.getTotalFinalEntries();
      this.getListCoaches()
      this.getListOfficials();
    }, 1000);
  }

  tournamentForm() {
    this.addEntryFormGroup = this.formBuilder.group({
      archerId: [""],
      tournamentId: [""],
      memberAssociation: [""],
      playingCategory: [""],
      coachId: [""],
      coachCategory: [""],
      entryAs: [""],
      gender: [null]
    });
  }

  openTournamentDetails(playingCategory) {
    this.selectedCategory = "";
    this.submit = false;
    this.loading = true;
    if (playingCategory == 'CompoundMen' || playingCategory == 'IndianRoundMen' || playingCategory == 'RecurveMen' || playingCategory == 'W1Men' || playingCategory == 'VI1Men' || playingCategory == 'VI2_3Men') {
      this.teamOfficialList = false;
      this.isEscortAttendant = false;
      this.coachList = false;
      this.isArcher = true;
      this.archerListObj = [];
      var men = this.ApprovedApplicants.filter(attr => attr.gender === 'Male');
      this.selectedArcherObj = {};
      for (const element of men) {
        this.archerListObj.push({
          label: element.memberId + '-' + element.fullName,
          value: element._id,
        });
      }

      if (playingCategory == 'W1Men') {
        this.selectedCategory = 'Para';
      }
       else if (playingCategory == 'VI1Men') {
        this.selectedCategory = 'VI 1';
      }
       else if (playingCategory == 'VI2_3Men') {
        this.selectedCategory = 'VI 2/3';
      }
       else {
        this.selectedCategory = playingCategory.replace('Men', '');
        let modifiedString = this.selectedCategory.replace(/([a-z])([A-Z])/g, "$1 $2");
        this.selectedCategory = modifiedString;
      }
      this.clearAndSetValidationForArcher();

    }
    if (playingCategory == 'CompoundWomen' || playingCategory == 'IndianRoundWomen' || playingCategory == 'RecurveWomen' || playingCategory == 'W1Women' || playingCategory == 'VI1Women' || playingCategory == 'VI2_3Women') {
      this.teamOfficialList = false;
      this.isEscortAttendant = false;
      this.coachList = false;
      this.isArcher = true;
      var women = this.ApprovedApplicants.filter(attr => attr.gender === 'Female');
      this.archerListObj = [];
      this.selectedArcherObj = {};
      for (const element of women) {
        this.archerListObj.push({
          label: element.memberId + '-' + element.fullName,
          value: element._id,
        });
      }
      if (playingCategory == 'W1Women') {
        this.selectedCategory = 'Para';
      } else if (playingCategory == 'VI1Women') {
        this.selectedCategory = 'VI 1';
      } else if (playingCategory == 'VI2_3Women') {
        this.selectedCategory = 'VI 2/3';
      } 
      else {
        this.selectedCategory = playingCategory.replace('Women', '');
        let modifiedString = this.selectedCategory.replace(/([a-z])([A-Z])/g, "$1 $2");
        this.selectedCategory = modifiedString;
      }
      this.clearAndSetValidationForArcher();
    }
    if (playingCategory == 'CoachMen' || playingCategory == 'CoachWomen') {
      this.isArcher = false;
      this.isEscortAttendant = false;
      this.teamOfficialList = false;
      this.coachList = true;
      this.archerListObj = [];
      this.selectedArcherObj = {};
      let gender = playingCategory == 'CoachMen' ? 'Male' : 'Female';
      var finalListData = this.tempCoachesData.filter(attr => attr.gender === gender);
      for (const element of finalListData) {
        this.archerListObj.push({
          label: element.memberId + '-' + element.fullName,
          value: element._id,
        });
      }
      this.selectedCategory = playingCategory;
      this.clearAndSetValidationForCoachAndOfficial()
    }
    if (playingCategory == 'EscortAttendant') {
        this.isArcher = false;
        this.coachList = false;
        this.teamOfficialList = false;
        this.isEscortAttendant = true;
    }
    if (playingCategory == 'OtherTeamOfficial') {
      this.isArcher = false
      this.coachList = false;
      this.isEscortAttendant = false;
      this.teamOfficialList = true;
      this.archerListObj = [];
      this.selectedArcherObj = {};
      for (const element of this.tempTeamOfficialData) {
        this.archerListObj.push({
          label: element.memberId + '-' + element.fullName,
          value: element._id,
        });
      }
      this.selectedCategory = playingCategory;
      this.clearAndSetValidationForCoachAndOfficial()
    }
    this.addEntryFormGroup.get('archerId').updateValueAndValidity();
    this.addEntryFormGroup.get('coachId').updateValueAndValidity();
    this.addEntryFormGroup.get('coachCategory').updateValueAndValidity();
    this.loading = false;
    this.addEntryModel = true;
  }

  clearAndSetValidationForCoachAndOfficial() {
    this.addEntryFormGroup.reset();
    this.addEntryFormGroup.get('archerId').clearValidators();
    this.addEntryFormGroup.get('coachId').clearValidators();
    this.addEntryFormGroup.get('coachCategory').clearValidators();
    this.addEntryFormGroup.controls['coachId'].setValidators([Validators.required]);
    this.addEntryFormGroup.controls['coachCategory'].setValidators([Validators.required]);
  }

  clearAndSetValidationForArcher() {
    this.addEntryFormGroup.reset();
    this.addEntryFormGroup.get('coachId').clearValidators();
    this.addEntryFormGroup.get('coachCategory').clearValidators();
    this.addEntryFormGroup.controls['archerId'].setValidators([Validators.required]);
  }

  closeTournamentDetails() {
    this.addEntryModel = false;
    this.archerListObj = []
  }

  get f() {
    return this.addEntryFormGroup.controls;
  }

  onSubmit() {
    this.submit = true;
    this.escortArcherErrorMsg = '';
    this.isEscortArcherErrorMsg = false;
    if (this.isEscortAttendant) {
      this.addEntryFormGroup.get('gender')?.setValidators(Validators.required);
    } else {
      this.addEntryFormGroup.get('gender')?.clearValidators();
    }
    this.addEntryFormGroup.get('gender')?.updateValueAndValidity();
    if(this.isEscortAttendant && this.addEntryFormGroup.get('archerId').value == ''){
      this.escortArcherErrorMsg = 'Please select archer';
      this.isEscortArcherErrorMsg = true;
      setTimeout(() => this.isEscortArcherErrorMsg = false, 3000);
      return;
    }
    if(this.isEscortAttendant && this.addEntryFormGroup.get('coachId').value == ''){
      this.escortErrorMsg = 'Please select escort/attendant';
      this.escortLimitMsg = true;
      setTimeout(() => this.escortLimitMsg = false, 3000);
      return;
    }
    if (this.addEntryFormGroup.invalid) {
      return;
    } else {
      if (this.coachList || this.teamOfficialList) {
        this.addEntryFormGroup.get('archerId').disable();
      } else {
        this.addEntryFormGroup.get('coachId').disable();
      }
      this.addEntryFormGroup.controls["tournamentId"].setValue(this.tournamentId);

      if (this.coachList || this.teamOfficialList || this.isArcher) {
        this.addEntryFormGroup.controls["memberAssociation"].setValue(this.selectedArcherObj.memberAssociation);
        if(this.coachList || this.isArcher){
         this.addEntryFormGroup.controls["gender"].setValue(this.selectedArcherObj.gender);
        }
      }
      if (this.coachList || this.teamOfficialList) {
        this.addEntryFormGroup.controls["playingCategory"].setValue(this.selectedArcherObj.playingCategory);
      } else {
        this.addEntryFormGroup.controls["playingCategory"].setValue(this.selectedCategory);
      }
      if (this.coachList || this.teamOfficialList) {
        this.addEntryFormGroup.controls["entryAs"].setValue(this.selectedArcherObj.accountType)
      }else if (this.isArcher) {
        this.addEntryFormGroup.controls["entryAs"].setValue('Archer');
        this.addEntryFormGroup.controls["gender"].setValue(this.selectedArcherObj.gender);
      }else if(this.isEscortAttendant){
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));
        let memberAssociation = userInfo.memberAssociation._id;
        this.addEntryFormGroup.get('archerId').enable();
        this.addEntryFormGroup.get('coachId').enable();
        this.addEntryFormGroup.controls["entryAs"].setValue('Escort/Attendant');
        this.addEntryFormGroup.controls["memberAssociation"].setValue(memberAssociation);

      }
      else {
        null;
      }
      let url = this.global.basePath + "tournament/addentryofarcher";

      this.global.PostRequest(url, this.addEntryFormGroup.value).subscribe(
        (res) => {
          this.addEntryFormGroup.reset();
          this.addEntryModel = false;
          setTimeout(() => {
            this.getTournamentList();
            this.getTournamentSummary();
            this.ApprovedApplicants = [];
            this.getArcherList();
            this.tempCoachesData = [];
            this.getListCoaches();
            this.escortAttendantListObj = [];
            this.getEscortAttendantInfo();
            this.tempTeamOfficialData = [];
            this.getListOfficials();
          }, 1000);
        },
        (err) => {
          if (err) {
            this.addEntryModel = true;
            // this.selectedArcherObj = []
            this.limitMsg = true;
            this.errorMsg = err.error.msg
            setTimeout(() => {
              this.limitMsg = false;
            }, 3000);
            console.log('errrr', err.error.msg)
          }
        }
      );


      this.addEntryFormGroup.get('archerId').enable();
      this.addEntryFormGroup.get('coachId').enable();
    }

  }

  getTournamentList() {
    const url =
      this.global.basePath +
      "tournament/listtournaments"
    this.global.GetRequest(url).subscribe((res: any) => {
      const data = res[0].json.data;
      this.tournamentList = data;

      var final = [];
      data.forEach(function (value, key) {
        final[value._id] = [];
        for (let categoryName in value?.categoryWiseCount) {
          if (value.categories[categoryName] != 0 && value.categories[categoryName] != null) {
            var tempObject = {};
            tempObject['key'] = categoryName;
            tempObject['value'] = value?.categoryWiseCount[categoryName];
            // this.selectedCategoryCount.push(tempObject);
            final[value._id].push(tempObject);
          }
        } 
      });
      this.selectedCategoryCount = final[this.tournamentId];
      this.tournamentObj = data.find(o => o._id == this.tournamentId);
      final[this.tournamentId].forEach(element => {
        element.maximum = this.tournamentObj.categories[element.key]
      });
      this.categoriesArray = [];
      this.categoriesArray = final[this.tournamentId];
      let sum = 0;
      let obj = this.tournamentObj?.categoryWiseCount
      for (let k in obj) {
        sum += +obj[k]
      }
      this.allFinalEntries = sum
    });
  }

  openViewDetails(tournamentId, categoryName) {
    this.noRecordFound = false;
    this.isArcher = false;
    this.coachList = false
    this.teamOfficialList = false;
    this.escortEntryList = false;
    this.viewCategoryName = this.formatCategoryKey(categoryName);
    this.listOfEntries = [];
    var name = "";
    var gender = "Male";
    if (categoryName == 'CompoundMen' || categoryName == 'CompoundWomen') {
      name = 'Compound';
      if (categoryName == 'CompoundWomen') {
        gender = 'Female'
      }
    }
    if (categoryName == 'IndianRoundMen' || categoryName == 'IndianRoundWomen') {
      name = 'IndianRound';
      if (categoryName == 'IndianRoundWomen') {
        gender = 'Female'
      }
    }
    if (categoryName == 'RecurveMen' || categoryName == 'RecurveWomen') {
      name = 'Recurve';
      if (categoryName == 'RecurveWomen') {
        gender = 'Female'
      }
    }
    if (categoryName == 'W1Men' || categoryName == 'W1Women') {
      name = 'Para';
      if (categoryName == 'W1Women') {
        gender = 'Female'
      }
    }
    let url;
    if (categoryName == 'CoachMen' || categoryName == 'CoachWomen') {
      name = 'Coach';
      if (categoryName == 'CoachWomen') {
        gender = 'Female'
      }
      url =
        this.global.basePath +
        "tournament/listofentries?playingCategory=" + name + '&tournamentId=' + tournamentId + '&gender=' + gender;
    }
    if (categoryName == 'VI1Men' || categoryName == 'VI1Women') {
      name = 'VI1';
      if (categoryName == 'VI1Women') {
        gender = 'Female'
      }
      url =
        this.global.basePath +
        "tournament/listofentries?playingCategory=" + name + '&tournamentId=' + tournamentId + '&gender=' + gender;
    }
    if (categoryName == 'VI2_3Men' || categoryName == 'VI2_3Women') {
      name = 'VI2_3';
      if (categoryName == 'VI2_3Women') {
        gender = 'Female'
      }
      url =
        this.global.basePath +
        "tournament/listofentries?playingCategory=" + name + '&tournamentId=' + tournamentId + '&gender=' + gender;
    }
    if (categoryName == 'OtherTeamOfficial') {

      url =
        this.global.basePath +
        "tournament/listofentries?tournamentId=" + tournamentId;
    } else if (categoryName == 'EscortAttendant') {
      url = this.global.basePath + "tournament/listofentries?tournamentId=" + tournamentId + '&playingCategory=Escort/Attendant';
    }
    else {
      url =
        this.global.basePath +
        "tournament/listofentries?playingCategory=" + name + '&tournamentId=' + tournamentId + '&gender=' + gender;
    }
    this.listOfEntries = null;

    this.noRecordFound = false;
    this.global.GetRequest(url).subscribe((res: any) => {
      let filteredUsers;
      if (categoryName == 'CoachMen' || categoryName == 'CoachWomen') {
        this.isArcher = false;
        this.teamOfficialList = false;
        this.escortEntryList = false;
        const data = res[0].json.data;
        let tempCoachList = [];
        tempCoachList = data.filter((coach) => {
          return coach.coachId.accountType == 'Coach';
        });
        let gender = categoryName == 'CoachMen' ? 'Male' : 'Female';
        this.listOfCoachEntries = tempCoachList.filter((coach) => {
          return coach.coachId.gender === gender;
        });
        if (this.listOfCoachEntries.length != 0) {
          this.coachList = true
          this.noRecordFound = true;
        }
      }
      else if (categoryName == 'EscortAttendant') {
        this.isArcher = false;
        this.coachList = false;
        this.teamOfficialList = false;
        const data = res[0].json.data;
        this.listOfEscortAttendantEntries = data
        if (this.listOfEscortAttendantEntries.length != 0) {
          this.escortEntryList = true;
          this.noRecordFound = true;
        }
      }
      else if (categoryName == 'OtherTeamOfficial') {
        this.isArcher = false;
        this.coachList = false;
        this.escortEntryList = false;
        const data = res[0].json.data;
        this.listOfTeamOfficialData = data.filter((teamOfficial) => {
          return teamOfficial.coachId.accountType == 'Team Officials';
        });
        if (this.listOfTeamOfficialData.length != 0) {
          this.teamOfficialList = true;
          this.noRecordFound = true;
        }
      }
      else {
        this.noRecordFound = true;
        this.coachList = false;
        this.escortEntryList = false;
        this.teamOfficialList = false;
        this.isArcher = true;
        const data = res[0].json.data;
        filteredUsers = data.filter((user) => {
          return user.archerId.gender === gender;
        });
      }


      this.listOfEntries = filteredUsers;

    });
    this.viewEntryModel = true;
  }

  closeViewDetails() {
    this.viewEntryModel = false;
  }

  getArcherList() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let memberAssociation = userInfo.memberAssociation._id;
    const url =
      this.global.basePath +
      "tournament/archerinfo?tournamentId=" + this.tournamentId +'&memberAssociation=' + memberAssociation
      ;
    this.global.GetRequest(url).subscribe((res: any) => {
      const array = res[0].json;
      this.ApprovedApplicants = array.approved;
    });
  }

  selectedArcher(event: any, type) {
    if (type == 'coach') {
      this.selectedArcherObj = this.tempCoachesData.find(o => o._id == event.value)
    }
    if (type == 'archer') {
      this.selectedArcherObj = this.ApprovedApplicants.find(o => o._id == event.value)
    }
    if (type == 'teamOfficial') {
      this.selectedArcherObj = this.tempTeamOfficialData.find(o => o._id == event.value)
    }

  }

  getTotalCategoryValueSum() {
    let sum = 0;
    let obj = this.tournamentObj?.categories
    for (let k in obj) {
      sum += +obj[k]
    }
    this.allEntries = sum
  }


  formatCategoryKey(key: string): string {
  if (!key) return '';
  // Normalize key (remove extra spaces)
  const normalizedKey = key.replace(/\s+/g, '');
  // Handle VI categories
  if (normalizedKey.startsWith('VI')) {
    let formatted = normalizedKey
      .replace('VI1', 'VI 1')
      .replace('VI2_3', 'VI 2/3')
      .replace('Men', ' Men')
      .replace('Women', ' Women');
    return `${formatted} (Visually Impaired)`;
  }

  if(normalizedKey == 'OtherTeamOfficial'){
    return "Other Team Officials (Team Manager)";
  }
  // Default formatting for other categories
  return key.replace(/([A-Z])/g, ' $1').trim();
}


  selectedCategoryValue(key: string): string {
    var response = this.selectedCategoryCount.find(o => o.key == key);
    return response?.value;
  }

  getTotalFinalEntries() {
    let sum = 0;
    let obj = this.tournamentObj?.categoryWiseCount
    for (let k in obj) {
      sum += +obj[k]
    }
    this.allFinalEntries = sum
  }

  transportForm() {
    this.addTransportFormGroup = this.formBuilder.group({
      type: ["", Validators.required],
      vehicleNumber: [""],
      arrivalPlace: ["", Validators.required],
      arrivalDateAndTime: ["", Validators.required],
      departurePlace: ["", Validators.required],
      departureDateAndTime: ["", Validators.required],
      tournamentId: [""],
      playingCategory: ["", Validators.required],
      numberOfPersons: ["", Validators.required]
    });
  }
  get v() {
    return this.addTransportFormGroup.controls;
  }
  transportOnSubmit() {
    this.submitted = true;
    if (this.addTransportFormGroup.invalid) {
      return;
    } else {
      this.buttonFlag = true;
      let url = this.global.basePath + "tournament/addtransportationdetails";
      this.global.PostRequest(url, { ...this.addTransportFormGroup.value, tournamentId: this.tournamentId }).subscribe(
        (res) => {
          this.addTransportFormGroup.reset();
          setTimeout(() => {
            this.getTransportationList();
            this.getTournamentSummary();
          }, 1000);
        },
        (err) => {
          if (err) {
            console.log('errrr', err)
          }
        }
      );
      this.buttonFlag = false;
      this.submitted = false
    }
  }

  getTransportationList() {
    const url =
      this.global.basePath +
      "tournament/listoftransportation/" + this.tournamentId
    this.transportationList = null
    this.global.GetRequest(url).subscribe((res: any) => {
      const data = res[0].json.data;
      this.transportationList = data;
    });
  }

  onTransportTypeChange(event: any) {
    if (event.value == 'By Train' || event.value == 'By Air') {
      this.showTicketField = true
      if (event.value == 'By Train') {
        this.labelName = 'Train Details'
      }
      if (event.value == 'By Air') {
        this.labelName = 'Flight Details'
      }
    } else {
      this.showTicketField = false
    }
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');
    this.router.navigate(['/login']);
    localStorage.removeItem(
      'onceOpenken'
    );
  }

  getTournamentSummary() {
    const url =
      this.global.basePath +
      "tournament/summaryoftournament/" + this.tournamentId
    this.summaryDetails = null
    this.global.GetRequest(url).subscribe((res: any) => {
      const data = res[0].json.data;
      this.summaryDetails = data;
    });
  }

  getListCoaches() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let memberAssociation = userInfo.memberAssociation._id;
    const url =
      this.global.basePath +
      "tournament/coachinfo?tournamentId=" + this.tournamentId + '&memberAssociation=' + memberAssociation;
    this.coachesListObject = []
    this.global.GetRequest(url).subscribe((res: any) => {
      this.tempCoachesData = res[0].json.approved;
    });
  }

  getListOfficials() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let memberAssociation = userInfo.memberAssociation._id;
    const url =
      this.global.basePath +
      "tournament/teamofficialinfo?tournamentId=" + this.tournamentId+ '&memberAssociation=' + memberAssociation;
    this.global.GetRequest(url).subscribe((res: any) => {
      this.tempTeamOfficialData = res[0].json.approved;
    });
  }

  onDeleteClick(entryId) {
    console.log('entryId', entryId)
    let url = this.global.basePath + "tournament/deleteentry/" + entryId;
    this.global.DeleteRequest(url).subscribe((res: any) => {
      this.closeViewDetails()
      this.getTournamentList()
      this.getListCoaches()
      this.getListOfficials()
      this.getArcherList()
      this.getTournamentSummary()
      this.getEscortAttendantInfo()
    });
  }

  downloadPDF() {
    this.loading = true;
    this.onlyPdfContent = true;
    setTimeout(() => {
    const doc = new jsPDF();
    const content = this.content.nativeElement;
    html2canvas(content).then((canvas) => {
      const imgData = canvas.toDataURL('image/png');
      const imgWidth = 210;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      doc.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      doc.save('Summary.pdf');
    });
      this.onlyPdfContent = false;
      this.loading = false;
    }, 1000);
  }

  onDeleteTransport(transportationId) {
    let url = this.global.basePath + "tournament/deletetransportation/" + transportationId;
    this.global.DeleteRequest(url).subscribe((res: any) => {
      this.getTransportationList()
      this.getTournamentSummary()
    });
  }

  getAssociationFullName(){
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let state = userInfo.memberAssociation.state;
    let name = userInfo.memberAssociation.name;
    this.associationFullName = state + '-'+ name;
  }

  checkDate(deadlineDate){
    let deadline = moment(deadlineDate);
    let today=moment();
    if (deadline.diff(today, "days") >= 0) {
      return true;
    }
  }

  backToList(){
    this.router.navigateByUrl("/tournament");
  }

  getEscortAttendantInfo() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let memberAssociation = userInfo.memberAssociation._id;
    const url =
      this.global.basePath +
      "tournament/escortattendantinfo?tournamentId=" + this.tournamentId +'&memberAssociation=' + memberAssociation
        ;
    this.global.GetRequest(url).subscribe((res: any) => {
      const array = res[0].json;
      this.ApprovedEscortAttendants = array.approved;
    });
  }

  getEscortAllArcherList() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let memberAssociation = userInfo.memberAssociation._id;
    const url =
      this.global.basePath +
      "common/allarcherlistforescortattendant?memberAssociation=" + memberAssociation;
      ;
    this.global.GetRequest(url).subscribe((res: any) => {
      const array = res[0].json;
      this.ApprovedEscortArcherList = array.approved;
    });
  }

  selectedGender(event: any) {
    this.escortArcherListObj = [];
    this.escortAttendantListObj = [];
    var withGenderFitter = this.ApprovedEscortArcherList.filter(attr => attr.gender === event.value);
      for (const element of withGenderFitter) {
        this.escortArcherListObj.push({
          label: element.memberId + '-' + element.fullName,
          value: element._id,
        });
      }
    
    let withGenderFitterEscort = this.ApprovedEscortAttendants.filter(attr => attr.gender === event.value);
      for (const element of withGenderFitterEscort) {
        this.escortAttendantListObj?.push({
          label: element.memberId + '-' + element.fullName,
          value: element._id,
        });
      }
  }
}
